var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.052,
    height: 28.103,
    viewBox: "0 0 28.052 28.103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke:#c4c4c4;stroke-linecap:round;stroke-linejoin:round;}.a{stroke-width:0.584px;}.b{stroke-width:1.169px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1491.42 -965.237)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1485.555,987.137c0,.294.366.216.592.132,1.315-.484,4.623-1.846,4.623-1.846l11.024-10.917s.522-.417-.175-1.117c-.578-.58-1.258-1.267-1.858-1.831s-1.05-.146-1.05-.146l-10.829,10.868s-.515,1.023-1.109,2.268c-.411.861-.29.6-1.064,2.122A1.365,1.365,0,0,0-1485.555,987.137Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1471.21,971.75c-.02-.033-11.186,11.282-11.21,11.268"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1469.769,973.445c.133-.152-11.188,11.059-11.181,11.074"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1480.36,985.289c-.006-.011-2.764-2.78-2.762-2.772"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1484.306,984.761a7.025,7.025,0,0,1,1.513,1.584"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-1477.993,965.885a16.229,16.229,0,0,0-4.078.856,13.4,13.4,0,0,0-6.91,5.806,13.044,13.044,0,0,0-1.817,7.725,12.906,12.906,0,0,0,3.464,8.056,13.538,13.538,0,0,0,5.588,3.708,13.773,13.773,0,0,0,5.2.7,12.468,12.468,0,0,0,5.389-1.516,13.087,13.087,0,0,0,6.872-9.042,12.961,12.961,0,0,0-2.984-11.612,13.183,13.183,0,0,0-7.9-4.473,13.336,13.336,0,0,0-2.76-.209"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.cd926df047bd87e4130d47bb65a2ac7b.svg";
export { ForwardRef as ReactComponent };